interface CurrencyDefinition {
  symbol: string;
  placement: 'prefix' | 'suffix';
}

const currencyConfig: { [key: string]: CurrencyDefinition } = {
  AUD: { symbol: '$', placement: 'prefix' },
  CAD: { symbol: '$', placement: 'prefix' },
  CHF: { symbol: 'Fr.', placement: 'suffix' },
  CNY: { symbol: '¥', placement: 'prefix' },
  CZK: { symbol: 'Kč', placement: 'suffix' },
  DKK: { symbol: 'kr', placement: 'suffix' },
  EUR: { symbol: '€', placement: 'prefix' },
  FOK: { symbol: 'kr', placement: 'suffix' },
  GBP: { symbol: '£', placement: 'prefix' },
  HKR: { symbol: 'kn', placement: 'suffix' },
  HUF: { symbol: 'Ft', placement: 'suffix' },
  ISK: { symbol: 'kr', placement: 'suffix' },
  JPY: { symbol: '¥', placement: 'prefix' },
  KRW: { symbol: '₩', placement: 'prefix' },
  NOK: { symbol: 'kr', placement: 'suffix' },
  PLN: { symbol: 'zł', placement: 'suffix' },
  RON: { symbol: 'L', placement: 'suffix' },
  RUB: { symbol: '₽', placement: 'suffix' },
  SEK: { symbol: 'kr', placement: 'suffix' },
  USD: { symbol: '$', placement: 'prefix' },
};

export function getCurrencyConfig(currency: string): CurrencyDefinition | undefined {
  return currencyConfig[currency];
}
